import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  MenuItem,
  ListItemText,
  Divider,
  ListSubheader,
  Checkbox,
  CircularProgress,
  Menu,
  Tooltip,
  IconButton,
  withStyles,
} from '@material-ui/core'
import { Delete, MoreVert } from '@material-ui/icons'
import { AccountMinus } from 'mdi-material-ui'
import { SUCCESS } from 'utils/statusConstants'
import language from 'utils/vast-languagepack'
import { deleteContact, getContact } from '../../actions/contacts'
import { deleteEntity } from 'actions/data'
import {
  addContactsToGroup,
  removeContactsFromGroup,
} from '../../actions/contacts/groups'
import { detail } from './Panel'
import { toggleDeleteDialog } from 'actions/view'
import API_URL from 'utils/ApiUrl'

export default connect(
  (state, { contact /* contactID */ }) => ({
    loadStatus: state.loadStatus.contactDetails?.[contact?.id],
    // loadStatus: state.loadStatus.contactDetails[contactID],
    groups: state.contacts.groupsByID,
    contactWithDetails: state.contacts.contactsWithEmailsByID?.[contact?.id],
  }),
  dispatch =>
    bindActionCreators(
      {
        deleteContact,
        addContactsToGroup,
        removeContactsFromGroup,
        getContact,
        toggleDeleteDialog,
        deleteEntity,
      },
      dispatch,
    ),
)(
  withStyles(theme => ({
    button: {
      margin: theme.spacing.unit,
    },
    progress: {
      margin: theme.spacing.unit * 2,
    },
    paper: {
      minWidth: '363.91px',
      height: '350px',
    },
    deleteButton: {
      position: 'sticky',
      bottom: 0,
      backgroundColor: '#fff',
      width: '100%',
      // '&:hover': {
      // 	backgroundColor: '#ebebeb',
      // },
    },
  }))(
    class ContactMenu extends Component {
      state = { moreAnchorElement: null }

      // componentDidMount() {
      //   this.props.getContact(this.props.contact?.id)
      // }

      handleMoreClick = (id, event) => {
        this.setState({ moreAnchorElement: event.currentTarget })
        this.props.getContact(id)
      }

      handleMoreClose = () => {
        this.setState({ moreAnchorElement: null })
      }

      handleDeleteContact = (contact, name) => {
        this.handleMoreClose()
        // window.confirm('Are you sure you want to delete this contact?') &&
        //   this.props.deleteContact(contact)
        this.props.toggleDeleteDialog({
          id: contact?.id,
          name,
          entityType: 'contact',
        })
      }

      handleContactGroupChange = (contact, groupID, name) => event => {
        const { addContactsToGroup, removeContactsFromGroup } = this.props
        event.target.checked
          ? addContactsToGroup({ [contact?.id]: true }, groupID)
          : removeContactsFromGroup({ [contact?.id]: true }, groupID)
      }

      render() {
        const {
          groups,
          contact,
          classes,
          loadStatus,
          groupID,
          contactWithDetails,
        } = this.props

        const { moreAnchorElement } = this.state

        const name =
          contact?.first_name || contact?.middle_name || contact?.last_name
            ? `${contact?.first_name ? `${contact?.first_name} ` : ''}${
                contact?.middle_name ? `${contact?.middle_name} ` : ''
              }${contact?.last_name ? `${contact?.last_name} ` : ''}`
            : `${detail(contact)}`

        return (
          <div>
            <Tooltip title={language.contacts.add.more}>
              <IconButton
                aria-label="More"
                aria-owns={
                  moreAnchorElement ? `more-menu-${contact?.id}` : null
                }
                aria-haspopup="true"
                onClick={event => this.handleMoreClick(contact?.id, event)}
                className={classes.button}
              >
                <MoreVert />
              </IconButton>
            </Tooltip>
            <Menu
              id={`more-menu-${contact?.id}`}
              anchorEl={moreAnchorElement}
              open={Boolean(moreAnchorElement)}
              onClose={() => this.handleMoreClose()}
              classes={{ paper: classes.paper }}
              MenuListProps={{ disablePadding: true }}
              // TransitionComponent={Fade}
            >
              {loadStatus !== SUCCESS ? (
                <CircularProgress
                  className={classes.progress}
                  color="secondary"
                />
              ) : (
                <div>
                  <ListSubheader style={{ backgroundColor: '#fff' }}>
                    {language.contacts.add.addToGroup}
                  </ListSubheader>
                  {Object.keys(groups).map(id => {
                    console.log(contactWithDetails)
                    console.log(contactWithDetails?.contact_groups)
                    console.log(contactWithDetails?.contact_groups?.[id])

                    return (
                      <MenuItem key={`contactGroup${id}onMenu${contact?.id}`}>
                        <Checkbox
                          checked={Boolean(
                            contactWithDetails?.contact_groups &&
                              contactWithDetails?.contact_groups?.[id],
                          )}
                          onChange={this.handleContactGroupChange(
                            contact,
                            id,
                            groups[id].name,
                          )}
                          value={id}
                        />
                        <ListItemText primary={`${groups[id].name}`} />
                      </MenuItem>
                    )
                  })}
                  <Divider />
                  <div className={classes.deleteButton}>
                    {groupID && (
                      <MenuItem
                        // className={classes.deleteButton}
                        onClick={() => {
                          this.props.removeContactsFromGroup(
                            { [contact?.id]: true },
                            groupID,
                          )
                          this.handleMoreClose()
                        }}
                      >
                        <AccountMinus />
                        <ListItemText
                          primary={`Remove ${name} from this group`}
                        />
                      </MenuItem>
                    )}
                    {this.props.campaignID && (
                      <MenuItem
                        // className={classes.deleteButton}
                        onClick={() => {
                          this.props
                            .deleteEntity(
                              null,
                              null,
                              `${API_URL}/campaign/${this.props.campaignID}/contact/${contact?.id}`,
                            )
                            .then(() =>
                              this.props.deleteThenFn(this.props.index),
                            )

                          this.handleMoreClose()
                        }}
                      >
                        <AccountMinus />
                        <ListItemText primary={`Remove from this campaign`} />
                      </MenuItem>
                    )}
                    <MenuItem
                      // className={classes.deleteButton}
                      onClick={() => this.handleDeleteContact(contact, name)}
                    >
                      <Delete />
                      <ListItemText primary={`Delete ${name}`} />
                    </MenuItem>
                  </div>
                </div>
              )}
            </Menu>
          </div>
        )
      }
    },
  ),
)
